(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-static/assets/javascripts/checkmark.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-static/assets/javascripts/checkmark.js');
"use strict";

const useWagerCurrentCorrectValues = svs.components.tipsen.hooksWager.useWagerCurrentCorrectValues;
const MatchCorrectStatus = svs.components.sport.tipsenShared.constants.MatchCorrectStatus;
const Icon = svs.ui.ReactIcon;
const Checkmark = _ref => {
  let userRow = _ref.userRow,
    drawResult = _ref.drawResult,
    bestBetRowResult = _ref.bestBetRowResult;
  const rowCorrectStatus = useWagerCurrentCorrectValues({
    userRow,
    drawResult,
    bestBetRowResult
  });
  const showCheckmark = typeof rowCorrectStatus === 'number' && rowCorrectStatus !== MatchCorrectStatus.POSSIBLE_WIN;
  const rectifyColor = rowCorrectStatus === MatchCorrectStatus.CORRECT ? 'fc-green' : 'fc-red';
  if (!showCheckmark) {
    return null;
  }
  return React.createElement("div", {
    className: "pg_coupon_static__checkmark"
  }, React.createElement(Icon, {
    color: rectifyColor,
    icon: "checkmark",
    size: "100"
  }));
};
setGlobal('svs.components.tipsen.couponStatic.Checkmark', Checkmark);

 })(window);